import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/greeley-digital-marketing")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => cityDigitalMarketingHead("Greeley", "greeley"),
  component: () => (
    <CityDigitalMarketingPage
      city="Greeley"
      slug="greeley"
      intro="Greeley's economy is industrial, agricultural, and growing fast. We help Greeley and Northern Colorado businesses generate more inbound leads and rank for the searches that matter most."
      whyUs={[
        "Northern Colorado expertise built into every campaign",
        "Local SEO tuned to Greeley's unique business landscape and search behavior",
        "GEO AI — because your Greeley customers are already asking AI for recommendations",
      ]}
      nearby={[
        { name: "Fort Collins", to: "/fort-collins-digital-marketing" },
        { name: "Boulder", to: "/boulder-digital-marketing" },
        { name: "Denver", to: "/denver-digital-marketing" },
        { name: "Aurora", to: "/aurora-digital-marketing" },
        { name: "Colorado Springs", to: "/colorado-springs" },
      ]}
      testimonial={{
        quote:
          "Transparent, fast, and they actually pick up the phone. Our website is finally a real sales asset.",
        role: "Landscaping Company Owner",
        city: "Castle Rock",
      }}
      industryLinks={industryLinksFor("Greeley")}
    />
  ),
});
